module.exports = require('./lib/linkify-html').default;
